import React, { useEffect } from "react";
import Footer from "../../../components/Footer";
import Header from "../../../components/Header";
import LeadershipMain from "./LeadershipMain";
import { useQuery } from "@tanstack/react-query";
import { getLeadershipRole } from "../../../services/leadershipRoleServices";

const Leadership = () => {
  useEffect(() => {
    document.title = "Leadership | Society of Aquaculture Professionals";
  }, []);

  const {
    data: leadershipRoles,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ["leadershipRoles"],
    queryFn: getLeadershipRole,
  });

  return (
    <>
      <Header />

      <LeadershipMain leadershipRoles={leadershipRoles?.data ?? null} />

      <Footer />
    </>
  );
};
export default Leadership;
